import { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { ActionsSpecs } from 'src/presentation/components/pages/sidekick/threads/SidekickActionsConstants';
import { addModifierToModule } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import { SidekickThreadEditorContext } from '../SidekickThreadEditorContext';

const useAddModifier = ({ moduleId, moduleSpec, readOnly }) => {
  const dispatch = useDispatch();
  const { allowedToAddModules, moduleSpecsMap } = useContext(SidekickThreadEditorContext);

  const handleAddModifier = (modifierName: string) => {
    const moduleName = moduleSpec.name;
    dispatch(addModifierToModule({ moduleName, modifierName, moduleId, history }));
  };

  const options = useMemo(() => {
    if (moduleSpec) {
      return moduleSpec.modifiers?.map(modifier => ({
        label: ActionsSpecs[modifier.name]?.presentableName || modifier.presentableName,
        value: modifier.name,
      }));
    }

    return allowedToAddModules
      .map(key => {
        return { label: ActionsSpecs[key]?.presentableName || moduleSpecsMap[key].presentableName || key, value: key };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [allowedToAddModules, moduleSpecsMap, moduleSpec]);

  const hasModifiers = moduleSpec && moduleSpec.modifiers?.length > 0;

  return { hasModifiers, readOnly, options, handleAddModifier };
};

export default useAddModifier;
